"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = fetchMyProjectData;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/is-array"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _uigCurrentEnvironmentUtil = require("@sfly/uig-current-environment-util");

var _Logger = _interopRequireDefault(require("./util/Logger"));

var loggerInstance = new _Logger.default('fetchMyProjectData');

function fetchMyProjectData(_x, _x2) {
  return _fetchMyProjectData.apply(this, arguments);
}

function _fetchMyProjectData() {
  _fetchMyProjectData = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(jwt, user) {
    var hostname, url, requestOptions;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            hostname = (0, _uigCurrentEnvironmentUtil.getHostname)('api2');
            url = "https://".concat(hostname, "/projects/v1/users/").concat(user.sfly_uid, "/projects/counts?activityState=A");
            requestOptions = {
              headers: {
                Authorization: "Bearer ".concat(jwt),
                'sfly-caller-id': 'UniversalHeader-ui-guild',
                'SFly-Apikey': (0, _uigCurrentEnvironmentUtil.getCurrentEnv)() !== 'production' ? 'djOlaaty605xAgYG2jOc9MwuwWtJ8NgG' : 'fVFk0J9J0zAGnGTDQNqHDSLxHYtna4t3'
              }
            };
            return _context.abrupt("return", fetch(url, requestOptions).then(function (response) {
              return response.json().then(function (data) {
                var myProjCnt = 0;
                (0, _isArray.default)(data) && data.map(function (ele) {
                  myProjCnt += ele.count;
                });
                console.log("fetchMyProjectData project count ->", myProjCnt);
                return myProjCnt;
              });
            }).catch(function (e) {
              loggerInstance.error('Error: while fetching my projects count', 'fetchMyProjectData', e);
              return null;
            }));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetchMyProjectData.apply(this, arguments);
}